export default __webpack_public_path__ + "static/bg-image-142434feca3e048337d7ea946cb9b5c2.jpg";